import { appLink } from '@app/config/appLink'
import { Link, useLocation } from 'react-router-dom'
import { ChevronRightIcon } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { useAtomValue } from 'jotai'
import { riskWorkspaceAtom } from '../../shared/state/riskWorkspace.atom'

export const WorkspaceBreadcrumbs = () => {
  const location = useLocation()
  const createMode = location.pathname.includes('create')
  const workspaceForm = useAtomValue(riskWorkspaceAtom)

  return (
    <div className="px-8 py-5 border-b flex justify-between">
      <div className="flex items-center gap-1">
        <Link to={appLink.workspaces.path} className="hover:opacity-100 opacity-75">
          Workspaces
        </Link>
        <ChevronRightIcon className="h-3.5" />
        <p className="">{workspaceForm.name.length ? workspaceForm.name : 'Untitled Workspaces'}</p>
        {createMode && (
          <Badge
            variant="secondary"
            className="text-xs capitalize text-neutral-950 text-[11px] bg-[#FEF9C3] ml-1"
          >
            Draft
          </Badge>
        )}
      </div>
      <Link className="text-primary" to={appLink.workspaces.path}>
        Discard
      </Link>
    </div>
  )
}
